import axios from "axios";
import config from "../config/app.conf.json";

const solutionUrl = (appId) =>
    `${config.api.solutions_svc_base_url}/v1/admin/solutions/${encodeURIComponent(appId)}`;

// Extra API call made when a function's switch changes, keyed by function id.
// Functions without an entry only update disabledFeatures. Add new ones here.
export const FUNCTION_REQUESTS = {
    NEW_DEALER_ENROLMENT: (appId, enabled) => ({
        url: `${solutionUrl(appId)}/subscription-management`,
        data: { subscription_management: { allowSubscriptions: enabled } }
    })
};

export const isFeatureEnabled = (disabledFeatures, feature) =>
    !(Array.isArray(disabledFeatures) && disabledFeatures.includes(feature));

// Preserves disabled features not managed by this page.
export const buildDisabledFeatures = (currentDisabled, functions, enabledState) => {
    const result = new Set(Array.isArray(currentDisabled) ? currentDisabled : []);
    Object.entries(enabledState || {}).forEach(([functionId, enabled]) => {
        const { feature } = functions[functionId];
        if (enabled) {
            result.delete(feature);
        } else {
            result.add(feature);
        }
    });
    return [...result];
};

export const getChangedFunctions = (functions, enabledState, disabledFeatures) =>
    Object.entries(functions)
        .filter(([functionId, func]) =>
            functionId in (enabledState || {}) &&
            enabledState[functionId] !== isFeatureEnabled(disabledFeatures, func.feature)
        )
        .map(([functionId, func]) => ({ functionId, enabled: enabledState[functionId], ...func }));

// Returns one { url, data } per PATCH to send for the given changes.
export const buildSaveRequests = ({ orgId, orgDisabledFeatures, appUpdates, changedApps }) => [
    ...(orgDisabledFeatures
        ? [{
            url: `${config.api.organizations_url}/admin/organizations/${encodeURIComponent(orgId)}`,
            data: { disabledFeatures: orgDisabledFeatures }
        }]
        : []),
    ...appUpdates.map(({ appId, disabledFeatures }) => ({
        url: `${config.api.solutions_svc_base_url}/v2/admin/solutions/${encodeURIComponent(appId)}`,
        data: { disabledFeatures }
    })),
    ...changedApps.flatMap(({ appId, functions }) =>
        functions
            .filter(({ functionId }) => FUNCTION_REQUESTS[functionId])
            .map(({ functionId, enabled }) => FUNCTION_REQUESTS[functionId](appId, enabled))
    )
];

export const sendSaveRequests = (requests, accessToken) => {
    const headers = { Authorization: `Bearer ${accessToken}` };
    return Promise.all(requests.map(({ url, data }) => axios.patch(url, data, { headers })));
};
